// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3l0Is","title":"FrontImage_title__3vvBi"};